import { styled } from "@mui/system";

export const BlogPageWrapper = styled("div")(() => ({
  //minHeight: "calc(100vh - 188px)",
  marginBottom: "40px",
}));

export const BlogHeader = styled("div")(() => ({
  paddingTop: 40,
  marginBottom: 32,
}));

export const BlogTitle = styled("h2")(() => ({
  fontSize: 32,
  fontWeight: 700,
  marginBottom: 8,
}));

export const BlogDesc = styled("p")(() => ({
  color: "#6b7280",
  fontSize: 16,
}));

export const BlogGrid = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
  gap: 24,
}));

export const BlogCard = styled("a")(() => ({
  textDecoration: "none",
  background: "#fff",
  borderRadius: 16,
  overflow: "hidden",
  boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
  transition: "all .25s ease",
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    transform: "translateY(-6px)",
    boxShadow: "0 16px 40px rgba(0,0,0,0.12)",
  },
}));

export const BlogThumb = styled("img")(() => ({
  position: "absolute",
  objectFit: "cover",
  width: "100%",
  height: "100%",
  top: 0,
  //background: "linear-gradient(135deg, #9333ea 0%, #2563eb 100%)",
}));

export const BlogContent = styled("div")(() => ({
  padding: 20,
  display: "flex",
  flexDirection: "column",
  height: "100%",
}));

export const BlogCardTitle = styled("h3")(() => ({
  fontSize: 18,
  fontWeight: 600,
  marginBottom: 8,

  display: "-webkit-box",
  WebkitLineClamp: 2,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

export const BlogCardDesc = styled("p")(() => ({
  fontSize: 14,
  color: "#6b7280",
  marginBottom: 12,

  display: "-webkit-box",
  WebkitLineClamp: 3,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
}));

export const BlogMeta = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
  color: "#9ca3af",
  marginTop: "auto",
}));
